import { InjectionToken } from '@angular/core';

export const ANSYN_ID = new InjectionToken('ANSYN_ID');
